// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1LAxg","amount":"Amount_amount__igEeo","tip":"Amount_tip__2y3Au","tipHeader":"Amount_tipHeader__1wKrA","tipsWrap":"Amount_tipsWrap__29wy1"};